import { TIMEOUT_LOG } from '../constants/actionTypes';
export function logTimeout(token, timeoutType, apiDomain, brokerConfigId) {
    return {
        type: TIMEOUT_LOG,
        token: token,
        timeoutType: timeoutType,
        apiDomain: apiDomain,
        brokerConfigId: brokerConfigId
    };
}
